// extracted by mini-css-extract-plugin
module.exports = {"compose":"Compose_compose__3tNWH","compose__input":"Compose_compose__input__1hDv4","compose__submit":"Compose_compose__submit__3wxXk"};